var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMalay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Malay",
    transform: "translate(21464 -2786)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4657",
    "data-name": "Rectangle 4657",
    width: 89,
    height: 89,
    rx: 10,
    transform: "translate(-21464 2786)",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8195",
    "data-name": "Path 8195",
    d: "M-4.7-14.219,2.869,7.15,10.4-14.219h7.973V15.245H12.278V7.191l.607-13.9L4.933,15.245H.764L-7.168-6.691l.607,13.882v8.054h-6.071V-14.219ZM35.145,9.194A1.884,1.884,0,0,0,34.082,7.5a12.068,12.068,0,0,0-3.41-1.1Q22.862,4.762,22.862-.236A6.016,6.016,0,0,1,25.28-5.1,9.755,9.755,0,0,1,31.6-7.055a10.5,10.5,0,0,1,6.668,1.963,6.186,6.186,0,0,1,2.5,5.1H34.922a2.83,2.83,0,0,0-.809-2.074,3.425,3.425,0,0,0-2.529-.82,3.5,3.5,0,0,0-2.287.668,2.108,2.108,0,0,0-.809,1.7,1.8,1.8,0,0,0,.921,1.568,9.472,9.472,0,0,0,3.106,1.032,25.371,25.371,0,0,1,3.683.981q4.634,1.7,4.634,5.889a5.711,5.711,0,0,1-2.57,4.846,11.086,11.086,0,0,1-6.637,1.852,11.579,11.579,0,0,1-4.887-.981,8.2,8.2,0,0,1-3.349-2.691,6.254,6.254,0,0,1-1.214-3.693h5.545a3.053,3.053,0,0,0,1.153,2.388,4.575,4.575,0,0,0,2.873.83,4.234,4.234,0,0,0,2.54-.637A1.983,1.983,0,0,0,35.145,9.194Z",
    transform: "translate(-21432.832 2833.273)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalay);
export default __webpack_public_path__ + "static/media/Malay.efdae42b.svg";
export { ForwardRef as ReactComponent };